/* eslint-disable no-nested-ternary */
import graphqlFetch from 'graphql';
import logger from 'libs/logger';
import { GraphQLPayloadData } from 'types/graphql.types';

export const getBrandById = (params: object) => {
  return graphqlFetch('GET_BRAND_BY_ID', params);
};

export const getUserAuthData = (params: object) => {
  return graphqlFetch('GET_USER_AUTH_DATA', params)
    .then(({ response: { data } }) => {
      const { getUserAuthData: userAuthData } = data as any;
      return userAuthData;
    })
    .catch((e) => {
      logger.error(e);
    });
};

export const getBrandList = (params: object, setBrands?: Function) => {
  graphqlFetch('GET_BRANDS', params)
    .then(({ response: { data } }) => {
      const { getBrands } = data as any;

      const modifiedData = getBrands.data.map((brand: any) => {
        if (!brand) {
          return {
            name: 'N/A',
            transport_method: 'N/A',
          };
        }

        return {
          id: brand.id,
          name: String(brand.name),
          transport_method:
            brand.transportMethodLanded && brand.transportMethodFob
              ? 'FOB Landed'
              : brand.transportMethodLanded
              ? 'Landed'
              : brand.transportMethodFob
              ? 'FOB'
              : 'N/A',
        };
      });

      if (typeof setBrands === 'function') {
        setBrands({
          data: modifiedData,
          pagination: getBrands.pagination,
        });
      }
    })
    .catch((e) => {
      logger.error(e);
    });
};

export const getBrands = (
  $fetch: (reqName: string, param: object) => Promise<any>,
  setBrands?: Function
) => {
  return $fetch('GET_BRANDS', {
    pagination: {
      pageSize: 50,
      startCursor: 1,
    },
    sort: {
      field: 'name',
      desc: false,
    },
  }).then(({ response: { data } }) => {
    const $brands = data.getBrands.data as GraphQLPayloadData[];
    const options = $brands
      ? $brands?.map((brand) => {
          const brandTransports = [];
          if (brand?.transportLanded) {
            brandTransports.push({ method: 'landed', markup: brand.transportLanded });
          }
          if (brand?.transportFob) {
            brandTransports.push({ method: 'fob', markup: brand.transportFob });
          }
          return {
            id: brand.id,
            name: brand.name,
            departments: brand.departments,
            transports: brandTransports,
          };
        })
      : [];

    options.unshift({
      id: '-1',
      name: '---- Select Brand ----',
      departments: '',
      transports: [],
    });

    return typeof setBrands === 'function' ? setBrands.bind(null, options) : () => {};
  });
};

export const deleteBrand = (params: object, submit: Function) => {
  return submit('DELETE_BRAND', params);
};
